import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6 fade-in">
      <div className="font-serif text-8xl text-npst-goldBorder">404</div>
      <h1 className="font-serif text-4xl text-npst-ink mt-4">Page not found</h1>
      <p className="text-npst-muted mt-3 max-w-md">The page you are looking for does not exist or may have been moved.</p>
      <Link to="/" className="inline-flex items-center gap-2 mt-8 px-7 py-3 bg-npst-navy text-white text-sm font-semibold uppercase tracking-[0.1em] rounded-sm hover:bg-npst-navyDeep transition-colors">Return Home</Link>
    </div>
  );
}
